<template>
    <div>
        <el-form-item :label="$t('标题')">
            <el-input v-model="data.title" :placeholder="$t('请输入标题')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('关联组件ID')">
            <el-input v-model="data.relationId" :placeholder="$t('关联组件ID')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('字体大小')">
            <el-input-number v-model="data.fontSize" controls-position="right" :placeholder="$t('请输入')"
                :min="0"></el-input-number>
        </el-form-item>
        <el-form-item :label="$t('字体加粗')">
            <el-switch active-value="bold" inactive-value="normal" v-model="data.fontWeight">
            </el-switch>
        </el-form-item>
        <el-form-item :label="$t('颜色值')">
            <l-input-color v-model="data.color" :placeholder="$t('请选择')"></l-input-color>
        </el-form-item>
        <el-form-item :label="$t('对齐方式')">
            <el-radio-group v-model="data.textAlign">
                <el-radio-button label="left">{{ $t('左') }}</el-radio-button>
                <el-radio-button label="center">{{ $t('中') }}</el-radio-button>
                <el-radio-button label="right">{{ $t('右') }}</el-radio-button>
            </el-radio-group>
        </el-form-item>
    </div>
</template>

<script>
export default {
    name: "config-txt",
    props: ['data'],
    data() {
        return {}
    },
    mounted(){
      console.log(this.data,"data=================")
    },
    methods: {

    }
}
</script>
